function title({ data, t }: { data: string, t: (val: string) => string }) {
  const dataLabel: { [keyword: string]: string } = {
    'board': t('board.del_board'),
    'bo-company': 'Delete Company',
    'bussines-process': t('general.message.del_bp_title'),
    'structure_view': t('general.message.del_structure_title'),
    'list_employee': t('general.message.del_employee_title'),
    '': t('board.del_board'),
  }
  return dataLabel[data]
}

export default title
